import { makeAutoObservable } from "mobx"
import { RootStore } from "./rootStore";

interface Modal {
    open: boolean;
    body: JSX.Element | null;
}

export default class ModalStore {
    rootStore: RootStore;
    modal: Modal = {
        open: false,
        body: null
    }

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this);
    }

    openModal = (content: JSX.Element) => {
        this.modal.open = true;
        this.modal.body = content;
    }

    closeModal = () => {
        this.modal.open = false;
        this.modal.body = null;
    }
}